import { Button, Paper, Typography, useTheme } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import type React from "react";
import { Link } from "react-router-dom";
import Grid2 from '@mui/material/Grid2';


const UnauthorizedPage: React.FC = () => {
	const theme = useTheme();

	return (
		<div style={{ padding: theme.spacing(4), height: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
			<Paper elevation={3} style={{ padding: theme.spacing(4), textAlign: "center", maxWidth: 600, borderRadius: "0.75rem" }}>
				<Grid2 container direction="column" alignItems="center" spacing={2}>
					<Grid2>
						<ErrorOutlineIcon style={{ fontSize: 80, color: theme.palette.error.main, marginBottom: theme.spacing(2) }} />
					</Grid2>
					<Grid2>
						<Typography variant="h4" style={{ marginBottom: theme.spacing(2), fontWeight: 600 }}>
							401 - Unauthorized
						</Typography>
					</Grid2>
					<Grid2>
						<Typography variant="body1" style={{ marginBottom: theme.spacing(4) }}>
							You don't have permission to access this page. Please contact your
							administrator if you believe this is an error.
						</Typography>
					</Grid2>
					<Grid2>
						<Button
							component={Link}
							to="/home"
							variant="contained"
							color="primary"
							style={{ marginTop: theme.spacing(2) }}>
							Go to Home
						</Button>
					</Grid2>
				</Grid2>
			</Paper>
		</div>
	);
};

export default UnauthorizedPage;
